import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    is: false
};
export const isReportAdmission = createSlice({
    initialState,
    name: 'admission',
    reducers: {
        showAdmissionReport: state => {
            state.is = true;
        },
        hideAdmissionReport: state => {
            state.is = false;
        }
    }
});
export default isReportAdmission.reducer;
